import React, { InputHTMLAttributes } from 'react';
import styled from 'styled-components';

import Text from './Text';

const InputContainer = styled.div`
  max-width: 384px;
  min-width: 250px;
  width: 100%;
  display: flex;
  flex-flow: column;
`;

const TextInput = styled.input`
  height: ${({ theme: { units } }) => units.sizes.ELEMENT_SMALL};
  apparence: none;
  border-color: transparent;
  background-color: ${({ theme: { colors } }) => colors.general.LIGHT};
  margin-bottom: ${({ theme: { units } }) => units.spacing.SMALL};
  padding-left: ${({ theme: { units } }) => units.spacing.MICRO};
  padding-right: ${({ theme: { units } }) => units.spacing.MICRO};
  border-radius: ${({ theme: { units } }) => units.sizes.BORDER_RADIUS};
  font-size: 0.9rem;
  font-weight: 600;
  font-family: 'Montserrat', sans-serif;
  color: ${({ theme: { colors } }) => colors.text.SOFT};
`;

interface InputProps extends InputHTMLAttributes<HTMLElement> {
  label: string,
}

function Input({
  label, ...rest
}: InputProps) {
  return (
    <InputContainer>
      <Text level="label">
        { label }
      </Text>
      <TextInput
        {...rest}
      />
    </InputContainer>
  );
}

export default Input;

Input.defaultProps = {
  label: 'Label',
}
